// extracted by mini-css-extract-plugin
export default {"Cookie":"Cookie_Cookie__w1ccr","Cookie__tile":"Cookie_Cookie__tile__vMswd","Cookie__description":"Cookie_Cookie__description__wboOE","Cookie__accept":"Cookie_Cookie__accept__QXMbS"};